document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-bundle-modal]').forEach(function (modal) {
    // Move the modal to the end of <body>. Minimog applies a CSS transform
    // to the product info column for its scroll-in animation, and a
    // transformed ancestor creates a new containing block for any
    // position:fixed descendant — which was trapping the modal inside the
    // "Product information" column instead of covering the viewport.
    // Re-parenting it under <body> guarantees position:fixed is relative
    // to the real viewport.
    if (modal.parentElement !== document.body) {
      document.body.appendChild(modal);
    }

    var img = modal.querySelector('[data-bundle-modal-image]');
    var title = modal.querySelector('[data-bundle-modal-title]');
    var desc = modal.querySelector('[data-bundle-modal-description]');
    var link = modal.querySelector('[data-bundle-modal-link]');

    function openModal(trigger) {
      img.src = trigger.getAttribute('data-image');
      img.alt = trigger.getAttribute('data-title');
      title.textContent = trigger.getAttribute('data-title');
      desc.textContent = trigger.getAttribute('data-description');
      link.href = trigger.getAttribute('data-url');
      modal.hidden = false;
      document.body.style.overflow = 'hidden';
    }

    function closeModal() {
      modal.hidden = true;
      document.body.style.overflow = '';
    }

    document.querySelectorAll('[data-bundle-trigger]').forEach(function (btn) {
      btn.addEventListener('click', function () { openModal(btn); });
    });

    modal.querySelectorAll('[data-bundle-close]').forEach(function (el) {
      el.addEventListener('click', closeModal);
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !modal.hidden) closeModal();
    });
  });
});